import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/monitoring.actions'
import { getUserMonitoring } from 'api/administration/monitoring/Get'
import { onHttpError } from 'helpers/access.helper'

async function get({ courseId, userId }: any) {
  return await getUserMonitoring(courseId, userId)
}

function* minitoringGetEffectSaga(action: any) {
  try {
    const data = yield call(get, action.payload)
    yield put(fromActions.Actions.userMonitoringGetSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
}

export function* userMonitoringGetWatcherSaga() {
  yield takeLatest(fromActions.USER_MONITORING_GET, minitoringGetEffectSaga)
}
